module.exports = __webpack_public_path__ + "img/9791155250143.e28c5f58.jpg";